import { components, ControlProps } from 'react-select';
import { makeStyles } from '@material-ui/styles';
import { GlobalLine } from '@bizzabo/design-system';
import { TimeZoneOption } from './types';

const Control = ({ children, ...props }: ControlProps<TimeZoneOption, false>) => {
    const classes = useStyles();

    return (
        <components.Control {...props}>
            <GlobalLine className={classes.globe} /> {children}
        </components.Control>
    );
};

const useStyles = makeStyles(
    theme => ({
        globe: {
            color: theme.customization.interactive.G40,
            fontSize: 17,
            marginRight: 6,
        },
    }),
    { classNamePrefix: 'time-zone-picker-control' }
);

export default Control;
